import { useQuery } from '@apollo/react-hooks';
import type {
  DeferredFeatureQuery,
  DeferredFeatureQueryVariables,
} from '@/generated/graphql';
import { DEFERRED_FEATURE_QUERY } from './deferredFeatureQuery.gql';
import { iwcAutofillEmailLookup } from '@/lib/emailLookup';
import { getToken, logger, updateIwcContext } from '@/lib';

export const useDeferredFeatures = (): void => {
  const { loading, error, data } = useQuery<
    DeferredFeatureQuery,
    DeferredFeatureQueryVariables
  >(DEFERRED_FEATURE_QUERY, {
    variables: {
      integrationType: 'XoSignupAuth',
      token: getToken(),
    },
  });

  const context = data?.otpLoginContext?.context;

  if (!loading && !error && context) {
    updateIwcContext(context);
    iwcAutofillEmailLookup();
  } else if (error) {
    const { message, stack } = error;
    logger.warn('useDeferredFeatures_error', { message, stack });
  }
};
